import { tvpil } from '../compat/tvpil';

// TODO: to fetch and cache category tree here
export function useCategoryTreeItem(referenceId: string) {
  return tvpil.categoryTreeItemsMap.get(referenceId);
}
